import React, { Component } from 'react';

class Aboutus extends Component {
    render() {
        const copy = [
            'Nature Way is more than a brand - it\'s our way of life.',
            'Inspired by generations of wisdom, rooted in nature, and crafted with care.',
            'From Cold Pressed oils extracted the traditional way to crystal-clear natural sugar, everything we create is pure, authentic, and made with respect for nature and people.',
            'We bring you the goodness of tradition, with the assurance of modern quality.',
        ];
        const values = [
            {
                icon: '/assets/img/about/about-value1.png',
                title: 'Authenticity',
                description: 'Honoring age-old traditions, we craft products rooted in authenticity and purity.',
            },
            {
                icon: '/assets/img/about/about-value2.png',
                title: 'Sustainability',
                description: 'We practice eco-friendly methods for a better, cleaner tomorrow.',
            },
            {
                icon: '/assets/img/about/about-value3.png',
                title: 'Community',
                description: 'Supporting and uplifting the community that nurtures our roots.',
            },
        ];
        const storySteps = [
            {
                year: '1950s',
                title: 'Family farming in Tamil Nadu (Temple)',
                icon: '/assets/img/about/about-story1.png',
            },
            {
                year: '1980s',
                title: 'Preserving Chekku methods (Oxen & Press)',
                icon: '/assets/img/about/about-story2.png',
            },
            {
                year: '2020s',
                title: 'Nature Way founded (Modem minimalist logo with a lest and chekku)',
                icon: '/assets/img/about/about-story3.png',
            },
        ];

        return (
            <>
            <div className="ps-about-page">
                <section className="ps-about-page__hero">
                    <div className="ps-about-page__shell">
                        <div className="ps-about-page__content">
                            {/* <span className="ps-about-page__eyebrow">About Us</span> */}
                            <div className="ps-about-page__heading">
                                <h1 className="ps-about-page__title">About Us</h1>
                                <img
                                    className="ps-about-page__line"
                                    src="/assets/img/about/about-line.png"
                                    alt=""
                                    aria-hidden="true"
                                />
                            </div>

                            <h2>Modern Wellness,<br/>rooted in timeless tradition</h2>

                            <div className="ps-about-page__copy">
                                {copy.map((paragraph) => (
                                    <p key={paragraph}>{paragraph}</p>
                                ))}
                            </div>
                        </div>

                        {/* <div className="ps-about-page__highlights">
                            {highlights.map((item, index) => (
                                <article className="ps-about-page__highlight" key={item.title}>
                                    <div className="ps-about-page__highlight-icon">
                                        <img src={item.icon} alt={item.title} />
                                    </div>
                                    <div className="ps-about-page__highlight-copy">
                                        <h2>{item.title}</h2>
                                        <p>{item.description}</p>
                                    </div>
                                    {index < highlights.length - 1 ? (
                                        <span className="ps-about-page__highlight-divider" aria-hidden="true" />
                                    ) : null}
                                </article>
                            ))}
                        </div> */}

                        
                    </div>
                </section>
                <section className="ps-about-page__values" aria-labelledby="about-values-title">
                    <div className="ps-about-page__shell ps-about-page__values-shell">
                        <div className="ps-about-page__values-intro">
                            <span className="ps-about-page__values-eyebrow">What guides us</span>
                            <h2 className="ps-about-page__values-title" id="about-values-title">
                                Our Values
                            </h2>
                            <p className="ps-about-page__values-subtitle">
                                The principles that shape every product we make and every relationship we build.
                            </p>
                        </div>

                        <div className="ps-about-page__values-grid">
                            {values.map((item) => (
                                <article className="ps-about-page__value-card" key={item.title}>
                                    <div className="ps-about-page__value-icon">
                                        <img src={item.icon} alt={item.title} />
                                    </div>
                                    <h3 className="ps-about-page__value-title">{item.title}</h3>
                                    <p className="ps-about-page__value-copy">{item.description}</p>
                                </article>
                            ))}
                        </div>
                    </div>
                </section>
                <section className="ps-about-page__story" aria-labelledby="about-story-title">
                    <div className="ps-about-page__story-shell">
                        {/* <div className="ps-about-page__story-heading">
                            <h2 className="ps-about-page__story-title" id="about-story-title">
                                Our Roots, Our Story
                            </h2>
                        </div> */}

                        <div className="">
                            <div className="ps-about-page__story-visual" aria-hidden="true">
                                <div className="ps-about-page__story-visual-frame">
                                    <img
                                        src="/assets/img/about/about-photo.png"
                                        alt=""
                                        className="ps-about-page__story-visual-image"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="ps-about-page__why" aria-labelledby="about-why-title">
                    <div className="container-fluid px-0">
                        <div className="row g-0">
                            <div className="col-12">
                                <div className="ps-about-page__why-shell">
                                    {/* <h2 className="ps-about-page__why-title" id="about-why-title">
                                        Why Choose Us
                                    </h2> */}
                                    <img
                                        className="ps-about-page__why-image"
                                        src="/assets/img/about/about-why.png"
                                        alt="Why Choose Us"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="ps-about-page__certifications" aria-labelledby="about-certifications-title">
                    <div className="container px-0">
                        <div className="row g-0">
                            <div className="col-12">
                                <div className="ps-about-page__certifications-shell">
                                    <div className="ps-about-page__certifications-header">
                                        <span className="ps-about-page__certifications-eyebrow">Trust &amp; Assurance</span>
                                        <h2 className="ps-about-page__certifications-title" id="about-certifications-title">
                                            Our Certifications
                                        </h2>
                                        <p className="ps-about-page__certifications-copy">
                                            Recognitions that reflect our commitment to quality, purity, and responsible practices.
                                        </p>
                                    </div>
                                    <div className="row row-cols-2 row-cols-sm-3 row-cols-lg-5 g-3 g-lg-4 justify-content-center ps-about-page__certifications-grid">
                                        {[
                                            '/assets/img/about/cert_1.png',
                                            '/assets/img/about/cert_2.png',
                                            '/assets/img/about/cert_3.png',
                                            '/assets/img/about/cert_4.png',
                                            '/assets/img/about/cert_5.png',
                                        ].map((src, index) => (
                                            <div className="col" key={src}>
                                                <div className="ps-about-page__cert-card">
                                                    <img
                                                        className="ps-about-page__cert-image"
                                                        src={src}
                                                        alt={`Certification ${index + 1}`}
                                                    />
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            </>
        );
    }
}

export default Aboutus;
